import { useQuery } from "@tanstack/react-query";
import { Axios } from "@/lib/axios";

export interface FeatureMatrixItem {
  key: string;
  name: string;
  isPackable: boolean;
  tiers: Record<string, number | null>;
}

export interface FeatureMatrixResponse {
  tierOrder: string[];
  tierDisplayNames: Record<string, string>;
  features: FeatureMatrixItem[];
}

export const useFeatureMatrix = () => {
  const { data, isLoading, error, refetch } = useQuery<FeatureMatrixResponse>({
    queryKey: ["pricing", "feature-matrix"],
    queryFn: async () => {
      const res = await Axios.get("/api/plans/feature-matrix");
      return res.data as FeatureMatrixResponse;
    },
    staleTime: 60 * 1000,
  });

  return {
    matrix: data,
    loading: isLoading,
    error: error ? (error as Error).message : null,
    refetch,
  };
};

